import { Link } from "react-router-dom";
import { useMe } from "@/context/MeContext";
import { STATUS, eur, num } from "@/lib/api";

const RATES = { bronze: 0.005, gold: 0.008, diamond: 0.01 };
const HIGHER = { bronze: ["gold", "diamond"], gold: ["diamond"], diamond: [] };

export const pointsFor = (amount, vat, mult) => Math.floor(Math.max(amount, 0) / (1 + vat / 100)) * mult;

export function PointsNeeded({ amount, testid, note }) {
  const { me } = useMe();
  const status = me?.status || "bronze";
  const need = Math.ceil(+(amount / RATES[status]).toFixed(6));
  const missing = me ? Math.max(need - me.balance, 0) : null;
  return (
    <div data-testid={testid} className="mt-2 rounded-lg border border-amber-500/20 bg-amber-500/[0.06] px-2.5 py-1.5 text-xs">
      <p className="text-slate-300">Tutto con i punti: <b className="text-amber-300">{num(need)} pt</b> <span className="text-slate-500">({STATUS[status].label}{note ? ` · ${note}` : ""})</span></p>
      {me && (missing === 0
        ? <p className="font-semibold text-emerald-400">Hai abbastanza punti per pagarlo tutto!</p>
        : <p className="text-slate-400">Hai {num(me.balance)} pt · ne mancano {num(missing)}</p>)}
    </div>
  );
}

export function PointsEarn({ amount, multiplier = 1, label, testid }) {
  const { me, config } = useMe();
  const status = me?.status || "bronze";
  const pts = pointsFor(amount, config?.vat_rate ?? 22, multiplier);
  const val = (lvl) => Math.floor(pts * RATES[lvl] * 100) / 100;
  return (
    <div data-testid={testid} className="mt-1 text-xs leading-relaxed">
      <p className="text-slate-300">
        {label && <span className="text-slate-500">{label}: </span>}
        <b className="text-amber-300">+{num(pts)} pt</b> = <b style={{ color: STATUS[status].color }}>{eur(val(status))}</b>
        <span className="text-slate-500"> da {STATUS[status].label}</span>
      </p>
      {HIGHER[status].length > 0 && pts > 0 && (
        <Link to="/diventa-premium" data-testid={testid ? `${testid}-upsell` : undefined} className="flex flex-wrap gap-x-2 text-slate-400 hover:text-slate-200">
          {HIGHER[status].map((l) => (
            <span key={l} className="line-through decoration-1" style={{ textDecorationColor: STATUS[l].color }}>
              {eur(val(l))} {STATUS[l].label}
            </span>
          ))}
        </Link>
      )}
    </div>
  );
}
